import * as Api from '@Api/index';
import {
  prefetchInfoStripe,
  prefetchLayoutData,
  prefetchMetaData,
  prefetchUITranslation,
  prefetchPage,
} from '@Navigation/prefetchers';

import type { LoaderFn } from '@Types/Router';

export const loader: LoaderFn = (query) => async (args) => {
  const { queryClient, country, region } = query;
  const { request } = args;

  if (typeof document === 'undefined' || !Api.getRequest()) {
    Api.setRequest(query);
  }

  return Promise.all([
    prefetchPage(request.url, queryClient),
    prefetchInfoStripe({ request, queryClient, country, region }),
    prefetchLayoutData(queryClient),
    prefetchMetaData(queryClient),
    prefetchUITranslation(queryClient),
  ]);
};
